import { ValidationModel, ValidationType } from "@/services/validation/types";

export const contentTemplateValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    width: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    height: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel
};
